/**
 * Boats Search Module
 * Extracted from BoatsSearch.cshtml inline JavaScript
 * Dependencies: jQuery, Choices.js, HTMX
 */

import Choices from 'choices.js';
import 'choices.js/public/assets/styles/choices.min.css';

// Export initialization function
export default function initializeBoatsSearch() {
    // Only initialize if boats search form exists on the page
    const boatsSearchForm = document.getElementById('boatsSearch');
    if (!boatsSearchForm) {
        return;
    }

    // Make Choices available globally for window.makesChoice = new Choices()
    window.Choices = Choices;

    // Include all the extracted JavaScript here
    // This will be populated from the extracted file


    // Attach the correct event listener for Make dropdown
    // itemTypesDd.addEventListener('change', itemTypesChange);

    // Function to submit the form - can be called from partial view
    function submitClick() {
        document.getElementById('BoatsSearchSubmit').click();
    }

    // Make submitClick globally available for HTMX callbacks
    window.submitClick = submitClick;

    // Helper function to ensure dropdowns appear on top
    function ensureDropdownZIndex() {
        // Apply high z-index to all Choices.js dropdowns
        const dropdowns = document.querySelectorAll('.choices__list--dropdown');
        dropdowns.forEach(dropdown => {
            dropdown.style.zIndex = '9999';
        });
    }

    // Function to handle make selection and create dynamic model selects
    function itemTypesChange() {
        const selectedItemTypes = Array.from(document.getElementById('ItemTypes').selectedOptions);
        const modelsContainer = document.getElementById('models-container');

        // If models container doesn't exist (e.g., on Featured Boats page), skip this functionality
        if (!modelsContainer) {
            return;
        }

        // Get currently existing model selects
        const existingSelects = Array.from(modelsContainer.querySelectorAll('.js-choice-models'));
        const existingMakeIds = existingSelects.map(select => select.dataset.makeId);
        
        // Get selected make IDs
        const selectedMakeIds = selectedItemTypes.map(option => option.value);
        
        // Remove model selects for makes that are no longer selected
        existingSelects.forEach(select => {
            const makeId = select.dataset.makeId;
            if (!selectedMakeIds.includes(makeId)) {
                // Destroy Choices.js instance if it exists
                const choiceInstance = window[`modelsChoice_${makeId}`];
                if (choiceInstance) {
                    choiceInstance.destroy();
                    delete window[`modelsChoice_${makeId}`];
                }
                
                // Remove the container
                const container = select.closest('.make-models-container');
                if (container) {
                    container.remove();
                }
            }
        });
        
        // Add model selects for newly selected makes
        selectedItemTypes.forEach((makeOption, index) => {
            const makeId = makeOption.value;
            const makeName = makeOption.textContent;
            
            // Only create if it doesn't already exist
            if (!existingMakeIds.includes(makeId)) {
                // Create container for this make's models
                const makeContainer = document.createElement('div');
                makeContainer.className = 'make-models-container mb-3';
                makeContainer.innerHTML = `
                    <label class="form-label oib-section-title">${makeName} Models:</label>
                    <select class="js-choice-models" data-make-id="${makeId}" data-make-name="${makeName}" name="BoatModels" multiple>
                        <option value="">Loading models...</option>
                    </select>
                `;
                modelsContainer.appendChild(makeContainer);
                
                // Load models for this make
                loadModelsForMake(makeId, makeName, index);
            }
        });
    }

    function loadModelsForMake(makeId, makeName, index) {
        $.ajax({
            url: '/BoatsSearch/GetModels',
            type: 'GET',
            data: { itemTypeId: makeId },
            success: function (data) {
                const select = document.querySelector(`[data-make-id="${makeId}"]`);
                if (select) {
                    // Preserve existing selections
                    const existingSelections = Array.from(select.selectedOptions).map(option => option.value);
                    
                    select.innerHTML = '';
                    
                    // Parse models from URL for this specific make
                    let modelsToSelect = [];
                    if (window.pendingModelSelections && window.pendingModelSelections.length > 0) {
                        // Normalize model names from URL for comparison
                        const normalizedUrlModels = window.pendingModelSelections.map(name => {
                            const lowerName = name.toLowerCase().trim();
                            // If name already has underscores, use as is; otherwise replace spaces with underscores
                            const normalized = lowerName.includes('_') ? lowerName : lowerName.replace(/\s+/g, '_');
                            // Remove leading/trailing underscores for comparison
                            return normalized.replace(/^_+|_+$/g, '');
                        });
                        
                        data.forEach(function (item) {
                            // Normalize option text: convert to lowercase and replace spaces with underscores
                            const optionText = item.model.trim().toLowerCase().replace(/\s+/g, '_').replace(/^_+|_+$/g, '');
                            
                            // Check if this model matches any from URL
                            if (normalizedUrlModels.includes(optionText)) {
                                modelsToSelect.push(item.systemFields.contentItemGUID);
                            }
                        });
                        
                    }
                    
                    data.forEach(function (item) {
                        const option = document.createElement('option');
                        option.value = item.systemFields.contentItemGUID;
                        option.textContent = item.model;
                        
                        // Check if this model should be selected
                        let shouldSelect = false;
                        if (existingSelections.includes(item.systemFields.contentItemGUID)) {
                            shouldSelect = true;
                        } else if (modelsToSelect.includes(item.systemFields.contentItemGUID)) {
                            shouldSelect = true;
                        }
                        
                        if (shouldSelect) {
                            option.selected = true;
                        }
                        select.appendChild(option);
                    });
                    
                    // Initialize Choices.js for this model select
                    const choiceId = `models-${makeId}`;
                    select.id = choiceId;
                    
                    if (window[`modelsChoice_${makeId}`]) {
                        window[`modelsChoice_${makeId}`].destroy();
                    }
                    
                    window[`modelsChoice_${makeId}`] = new Choices(`#${choiceId}`, {
                        removeItemButton: true,
                        searchEnabled: true,
                        searchChoices: true,
                        noResultsText: 'No models found',
                        noChoicesText: 'No models available',
                        itemSelectText: 'Click to select',
                        loadingText: 'Loading models...',
                        placeholder: true,
                        placeholderValue: `Select ${makeName} models...`,
                        searchPlaceholderValue: 'Search models...',
                        shouldSort: false
                    });

                    // Add high z-index to the dropdown container
                    setTimeout(() => {
                        const dropdown = document.querySelector(`#${choiceId} + .choices .choices__list--dropdown`);
                        if (dropdown) {
                            dropdown.style.zIndex = '9999';
                        }
                    }, 100);

                    // Add auto-collapse functionality to models dropdown
                    select.addEventListener('change', function() {
                        window[`modelsChoice_${makeId}`].hideDropdown();
                    });

                    // Ensure dropdown appears on top when opened
                    select.addEventListener('showDropdown', function() {
                        ensureDropdownZIndex();
                    });
                    
                    // After Choices.js is initialized, select models from URL if available
                    // Get selected values from native select (option.selected = true)
                    const selectedFromNative = Array.from(select.selectedOptions).map(opt => opt.value);
                    
                    // Also check pendingModelSelections from URL and add any matching models
                    let allSelectedValues = [...selectedFromNative];
                    if (window.pendingModelSelections && window.pendingModelSelections.length > 0) {
                        const modelNames = window.pendingModelSelections;
                        
                        // Find matching model values by comparing normalized names
                        Array.from(select.options).forEach(option => {
                            // Normalize option text: convert to lowercase and replace spaces with underscores
                            // Remove leading/trailing underscores for comparison
                            const optionText = option.textContent.trim().toLowerCase().replace(/\s+/g, '_').replace(/^_+|_+$/g, '');
                            // Normalize model names from URL: they already have underscores, just lowercase
                            // But also handle case where model name might have spaces (legacy URLs)
                            // Remove leading/trailing underscores for comparison
                            const normalizedModelNames = modelNames.map(name => {
                                const lowerName = name.toLowerCase().trim();
                                // If name already has underscores, use as is; otherwise replace spaces with underscores
                                const normalized = lowerName.includes('_') ? lowerName : lowerName.replace(/\s+/g, '_');
                                // Remove leading/trailing underscores for comparison
                                return normalized.replace(/^_+|_+$/g, '');
                            });
                            const isMatch = normalizedModelNames.includes(optionText);
                            if (isMatch && !allSelectedValues.includes(option.value)) {
                                allSelectedValues.push(option.value);
                            }
                        });
                    }
                    
                    // Set the values in Choices.js using its API
                    if (allSelectedValues.length > 0) {
                        setTimeout(() => {
                            try {
                                const choicesInstance = window[`modelsChoice_${makeId}`];
                                if (choicesInstance) {
                                    // Use setChoiceByValue instead of setValue - it works better for selecting existing options
                                    allSelectedValues.forEach(value => {
                                        choicesInstance.setChoiceByValue(value);
                                    });
                                    // Refresh to ensure UI updates
                                    choicesInstance.refresh(true);
                                }
                            } catch (error) {
                                // Ignore errors
                            }
                        }, 200);
                    }
                }
            },
            error: function (xhr, status, error) {
                const select = document.querySelector(`[data-make-id="${makeId}"]`);
                if (select) {
                    select.innerHTML = '<option value="">Error loading models</option>';
                }
            }
        });
    }


    function showButtonLoading() {
        const submitBtn = document.getElementById('BoatsSearchSubmit');
        const buttonText = document.getElementById('submitButtonText');
        const buttonSpinner = document.getElementById('submitButtonSpinner');

        if (submitBtn && buttonText && buttonSpinner) {
            submitBtn.disabled = true;
            buttonText.classList.add('d-none');
            buttonSpinner.classList.remove('d-none');
        }
    }

    function hideButtonLoading() {
        const submitBtn = document.getElementById('BoatsSearchSubmit');
        const buttonText = document.getElementById('submitButtonText');
        const buttonSpinner = document.getElementById('submitButtonSpinner');

        if (submitBtn && buttonText && buttonSpinner) {
            submitBtn.disabled = false;
            buttonText.classList.remove('d-none');
            buttonSpinner.classList.add('d-none');
        }
    }

    // Функция для отключения всех select элементов
    function disableAllSelects() {
        const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
        if (!isIOS) {
            return;
        }
        const allSelects = document.querySelectorAll('select');
        allSelects.forEach(select => {
            // Сохраняем предыдущее состояние
            select.dataset.prevDisabled = select.disabled;
            select.dataset.prevPointerEvents = select.style.pointerEvents;

            // Отключаем select
            select.disabled = true;
            select.style.pointerEvents = 'none';
            select.style.opacity = '0.5';

            // Убираем фокус
            select.blur();
        });
    }

    // Функция для включения всех select элементов
    function enableAllSelects() {
        const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
        if (!isIOS) {
            return;
        }
        const allSelects = document.querySelectorAll('select');
        allSelects.forEach(select => {
            // Восстанавливаем предыдущее состояние
            if (select.dataset.prevDisabled !== undefined) {
                select.disabled = select.dataset.prevDisabled === 'true';
                delete select.dataset.prevDisabled;
            } else {
                select.disabled = false;
            }

            if (select.dataset.prevPointerEvents !== undefined) {
                select.style.pointerEvents = select.dataset.prevPointerEvents;
                delete select.dataset.prevPointerEvents;
            } else {
                select.style.pointerEvents = 'auto';
            }

            select.style.opacity = '1';
        });
    }

    // Function to sync filter values from main form to results form
    function syncFilterValues() {
        const mainForm = document.getElementById('boatsSearch');
        const resultsForm = document.getElementById('boatResultsForm');

        if (mainForm && resultsForm) {

            // Sync all form elements except buttons
            const mainInputs = mainForm.querySelectorAll('input:not([type="submit"]):not([type="button"]), select');
            mainInputs.forEach(input => {
                const correspondingInput = resultsForm.querySelector(`[name="${input.name}"]`);
                if (correspondingInput) {
                    if (input.type === 'checkbox') {
                        correspondingInput.value = input.checked;
                    } else {
                        correspondingInput.value = input.value;
                    }
                }
            });

            // Sync SortBy and PageSize from partial view dropdowns to results form
            const pageNumberElement = document.getElementById('PageNumber');

            if (pageNumberElement) {
                let pageNumberInput = resultsForm.querySelector('input[name="PageNumber"]');
                if (!pageNumberInput) {
                    pageNumberInput = document.createElement('input');
                    pageNumberInput.type = 'hidden';
                    pageNumberInput.name = 'PageNumber';
                    resultsForm.appendChild(pageNumberInput);
                }
                pageNumberInput.value = pageNumberElement.value;

                // Also sync to main form
                const mainPageNumberInput = mainForm.querySelector('input[name="PageNumber"]');
                if (mainPageNumberInput) {
                    mainPageNumberInput.value = pageNumberElement.value;
                }
            }
        }
    }

    function updateImagesGalaries() {
        const oibImages = document.querySelectorAll('.oib-image');
        oibImages.forEach(oibImage => {
            const hoverableUnits = oibImage.querySelectorAll('.oib-hoverable-unit');
            const photoLines = oibImage.querySelectorAll('.oib-photo-line');
            const mainImage = oibImage.querySelector('.oib-main-image');

            hoverableUnits.forEach((unit, index) => {
                unit.addEventListener('mouseover', function () {
                    const imageUrl = this.getAttribute('data-image');
                    const altText = this.getAttribute('data-alt');
                    if (mainImage) {
                        mainImage.src = imageUrl;
                        if (altText) {
                            mainImage.alt = altText;
                        }
                    }
                    photoLines.forEach(line => line.classList.remove('active'));
                    // Check if photoLine exists at this index before accessing classList
                    if (photoLines[index]) {
                        photoLines[index].classList.add('active');
                    }
                });

                unit.addEventListener('mouseout', function () {
                    setTimeout(() => {
                        if (!oibImage.querySelector('.oib-hoverable-unit:hover')) {
                            const firstImageUrl = hoverableUnits[0].getAttribute('data-image');
                            const firstAltText = hoverableUnits[0].getAttribute('data-alt');
                            if (mainImage) {
                                mainImage.src = firstImageUrl;
                                if (firstAltText) {
                                    mainImage.alt = firstAltText;
                                }
                            }
                            photoLines.forEach(line => line.classList.remove('active'));
                            // Check if first photoLine exists before accessing classList
                            if (photoLines[0]) {
                                photoLines[0].classList.add('active');
                            }
                        }
                    }, 10);
                });
            });

            oibImage.addEventListener('mouseover', function (event) {
                if (!event.target.closest('.oib-hoverable-unit')) {
                    const firstImageUrl = hoverableUnits[0].getAttribute('data-image');
                    const firstAltText = hoverableUnits[0].getAttribute('data-alt');
                    if (mainImage) {
                        mainImage.src = firstImageUrl;
                        if (firstAltText) {
                            mainImage.alt = firstAltText;
                        }
                    }
                    photoLines.forEach(line => line.classList.remove('active'));
                    // Check if first photoLine exists before accessing classList
                    if (photoLines[0]) {
                        photoLines[0].classList.add('active');
                    }
                }
            });
        });
    }
    // Flag to track if the current request is from pagination
    let isPaginationRequest = false;
    let paginationPageNumber = null;

    // Listen for HTMX beforeRequest to detect pagination vs filter actions
    document.addEventListener('htmx:beforeRequest', function (event) {
        if (event.target.closest('.page-numbers')) {
            isPaginationRequest = true;

            // Extract page number for URL update
            const link = event.target.closest('a');
            if (link) {
                paginationPageNumber = link.getAttribute('data-page');
            }
        } else {
            // Reset pagination flag if not a pagination request
            isPaginationRequest = false;
            paginationPageNumber = null;

            // If this is a form submission (filter action), reset PageNumber to 1
            // But only if it's not a browser navigation (popstate)
            if (event.target.id === 'boatsSearch' && !isPopstateNavigation) {
                const pageNumberInput = event.target.querySelector('input[name="PageNumber"]');
                if (pageNumberInput) {
                    pageNumberInput.value = '1';
                }
                // Ensure popstate flag is false for filter actions
                isPopstateNavigation = false;
            }
        }

        // Disable all selects for iOS devices
        disableAllSelects();

        // Show loading state for the submit button
        showButtonLoading();
    });

    // Listen for HTMX events to sync values after partial updates
    document.addEventListener('htmx:afterSwap', function (event) {
        if (event.detail.target.id === 'boat-results-container') {
            
            // Update meta title and description from response headers
            updateMetaAndTitleAfterSwap(event);

            // Hide mobile filter sidebar after successful form submission (not pagination)
            if (!isPaginationRequest) {
                const mobileFiltersBtn = document.getElementById('mobileFiltersBtn');
                const filterSidebar = document.getElementById('mainFilterSidebar');
                if (mobileFiltersBtn && filterSidebar && mobileFiltersBtn.classList.contains('active')) {
                    mobileFiltersBtn.classList.remove('active');
                    filterSidebar.style.display = 'none';
                }
            }

            // The model already contains the correct PageNumber value from the server
            // We don't need to manually set it - just use what's already in the hidden input

            // Small delay to ensure DOM is ready
            setTimeout(syncFilterValues, 100);
            
            // Re-attach event listeners for dropdowns in partial view
            //setTimeout(attachPartialViewListeners, 100);

            // Update URL parameters with all current filter values AFTER swap is complete
            // This ensures browser history is only updated after successful content load
            setTimeout(function () {
                if (isPaginationRequest && paginationPageNumber) {
                    // For pagination, get all current filters and update with new page number
                    const filterString = getFilterString(false); // Not a filter action, include PageNumber
                    const url = new URL(window.location.href);
                    
                    url.searchParams.delete('PageNumber');
                    url.searchParams.delete('page'); // Also remove legacy 'page' parameter
                    if (paginationPageNumber && paginationPageNumber !== '' && paginationPageNumber !== 'null' && paginationPageNumber !== '1') {
                        url.searchParams.set('PageNumber', paginationPageNumber);
                    }
                    
                    window.history.pushState({}, '', url.toString());
                } else {
                    // For filter actions, use normal URL update with filter flag
                    updateUrlWithFilters(true); // Pass true to indicate this is a filter action
                }

                // Reset popstate flag after URL update is complete
                isPopstateNavigation = false;
                // Reset pagination flags
                isPaginationRequest = false;
                paginationPageNumber = null;
            }, 200);

            updateImagesGalaries();            
        }

        // Re-enable all selects after error
        setTimeout(() => {
            enableAllSelects();
            hideButtonLoading();
        }, 100);
    });

    // Handle HTMX errors to reset popstate flag
    document.addEventListener('htmx:responseError', function (event) {
        if (event.detail.target.id === 'boat-results-container') {
            isPopstateNavigation = false;
            isPaginationRequest = false;
            paginationPageNumber = null;
        }
        // Re-enable all selects after error
        setTimeout(() => {
            enableAllSelects();
            hideButtonLoading();
        }, 100);

    });

    // Handle HTMX timeout/abort to reset popstate flag
    document.addEventListener('htmx:timeout', function (event) {
        if (event.detail.target.id === 'boat-results-container') {
            isPopstateNavigation = false;
            isPaginationRequest = false;
            paginationPageNumber = null;
        }

        // Re-enable all selects after error
        setTimeout(() => {
            enableAllSelects();
            hideButtonLoading();
        }, 100);

    });

    const formFieldNames = ['DriveTypeID', 'FromLength', 'ToLength',
                               'FromYear', 'ToYear', 'FromHours', 'ToHours', 'FromPrice', 'ToPrice',
                               'Saltwater', 'IsOmitWithNoPrice', 'ZipCode', 'IsGallery', 'PageNumber', 'Distance'];
                               // Note: ItemTypes and BoatModels are excluded from URL but still handled by form state

    // Function to generate page title based on current form values
    async function generatePageTitle() {
        const form = document.getElementById('boatsSearch');
        if (!form) return '';
        let models = [];
        const formData = new FormData(form);
        const makes = Array.from(document.getElementById('ItemTypes').selectedOptions)
                   .map(option => option.value);
        const modelsInputs = document.getElementById('Models');
        if (modelsInputs != null) {
                models = Array.from(document.getElementById('Models').selectedOptions)
                    .map(option => option.value);    
            }

        // Get year values
        const fromYear = formData.get('FromYear');
        const toYear = formData.get('ToYear');
        const fromYearNum = fromYear && fromYear !== 'null' && fromYear !== '0' ? parseInt(fromYear) : null;
        const toYearNum = toYear && toYear !== 'null' ? parseInt(toYear) : null;

        // Get location values
        const zipCode = formData.get('ZipCode');
        const distance = formData.get('Distance');
        const stateValues = formData.getAll('State').filter(s => s && s !== '');

        const data = {
                itemTypes: makes,
                boatModels: models,
                fromYear: fromYearNum,
                toYear: toYearNum,
                states: stateValues,
                zipCode: zipCode,
                distance: distance
        };

        const response = await fetch('/BoatsSearch/GetPageTitle', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(data),
         });

        const result = await response.text();

        return result;
    }

    // Add event listeners for form changes that should update the title
    function attachTitleUpdateListeners() {
        // Removed real-time title updates - now only updates on htmx:afterSwap and page load
        // This function is kept for compatibility but no longer attaches listeners
    }

    function getPartialPathUrl(){
        const pathUrl = document.getElementById('PartialUrlPath');

        let partialPathUrl = '';

        if (pathUrl && pathUrl.value) {
            partialPathUrl = pathUrl.value;
        }

        return partialPathUrl;
    }

    // Function to get filter string from form
    function getFilterString(isFilter = false) {
        const form = document.getElementById('boatsSearch');
        const resultsForm = document.getElementById('boatResultsForm');
        if (!form) return '';

        // Set flag to track filter actions
        isCurrentActionFilter = isFilter;

        const formData = new FormData(form);
        const urlParams = new URLSearchParams();

        // Build path-based URL with SEO-friendly structure
        let pathUrl = '/used-ski-boats/';
        
        // Get SortBy and PageSize from the partial view dropdowns
        const sortByElement = document.getElementById('SortBy');
        const pageSizeElement = document.getElementById('pageSize');

        if (sortByElement && sortByElement.value && sortByElement.value !== '') {
            urlParams.set('SortBy', sortByElement.value);
        }

        if (pageSizeElement && pageSizeElement.value && pageSizeElement.value !== '' && pageSizeElement.value !== '24') {
            urlParams.set('PageSize', pageSizeElement.value);
        }

        // Build SEO-friendly path segments
        const pathSegments = [];

        // Handle states
        const stateValues = formData.getAll('State').filter(s => s && s !== '');
        if (stateValues.length > 0) {
            // Convert state names to lowercase, replace spaces with underscore, and join with dash
            const stateNames = stateValues.map(state => state.toLowerCase().replace(/\s+/g, '_'));
            pathSegments.push(`states:${stateNames.join('-')}`);
        }

        // Handle zip code
        const zipCode = formData.get('ZipCode');
        if (zipCode && zipCode !== '') {
            pathSegments.push(`zip-${zipCode}`);
            
            // Only add radius if there's a zip code
            const distance = formData.get('Distance');
            if (distance && distance !== '' && distance !== 'null') {
                pathSegments.push(`radius-${distance}`);
            }
        }

        // Handle drive type
        const driveTypeID = formData.get('DriveTypeID');
        if (driveTypeID && driveTypeID !== '' && driveTypeID !== 'null') {
            const driveTypeSelect = form.querySelector('select[name="DriveTypeID"]');
            if (driveTypeSelect) {
                const selectedOption = driveTypeSelect.querySelector(`option[value="${driveTypeID}"]`);
                if (selectedOption) {
                    const driveTypeName = selectedOption.textContent.toLowerCase().replace(/\s+/g, '-');
                    pathSegments.push(`drivetype-${driveTypeName}`);
                }
            }
        }

        // Handle makes and models
        const itemTypeValues = formData.getAll('ItemTypes').filter(s => s && s !== '');
        
        if (itemTypeValues.length > 0) {
            const makeModelPairs = [];
            const selectedMakes = Array.from(document.getElementById('ItemTypes').selectedOptions)
                .map(option => option.textContent);
            
            // Get all selected models from dynamic model selects
            const allModelSelects = document.querySelectorAll('.js-choice-models');
            const selectedModels = [];
            
            allModelSelects.forEach(select => {
                const makeId = select.dataset.makeId;
                const makeName = select.dataset.makeName;
                const selectedOptions = Array.from(select.selectedOptions);
                
                selectedOptions.forEach(option => {
                    const modelName = option.textContent;
                    const cleanMake = makeName.replace(/\s+Boats?$/i, '').toLowerCase().replace(/\s+/g, '_');
                    makeModelPairs.push(`${cleanMake}:${modelName.toLowerCase().replace(/\s+/g, '_')}`);
                });
            });
            
            // Add makes without models
            selectedMakes.forEach(makeName => {
                const cleanMake = makeName.replace(/\s+Boats?$/i, '').toLowerCase().replace(/\s+/g, '_');
                // Check if this make has any models selected
                const hasModels = makeModelPairs.some(pair => pair.startsWith(cleanMake + ':'));
                if (!hasModels) {
                    makeModelPairs.push(cleanMake);
                }
            });
            
            if (makeModelPairs.length > 0) {
                const encodedPairs = makeModelPairs.map(pair => {
                    if (pair.includes(':')) {
                        const [make, model] = pair.split(':');
                        return `${make}:${encodeURIComponent(model)}`;
                    }
                    return pair;
                });
                pathSegments.push(`makemodel-${encodedPairs.join('&')}`);
            }
        }

        // Handle length range
        const fromLength = formData.get('FromLength');
        const toLength = formData.get('ToLength');
        if ((fromLength && fromLength !== '' && fromLength !== 'null') || (toLength && toLength !== '' && toLength !== 'null')) {
            const effectiveFromLength = (fromLength && fromLength !== '' && fromLength !== 'null') ? fromLength : '0';
            const effectiveToLength = (toLength && toLength !== '' && toLength !== 'null') ? toLength : '';
            const lengthRange = effectiveToLength 
                ? `length-${effectiveFromLength}-${effectiveToLength}` 
                : `length-${effectiveFromLength}`;
            pathSegments.push(lengthRange);
        }

        // Handle year range
        const fromYear = formData.get('FromYear');
        const toYear = formData.get('ToYear');
        if ((fromYear && fromYear !== '' && fromYear !== 'null') || (toYear && toYear !== '' && toYear !== 'null')) {
            const effectiveFromYear = (fromYear && fromYear !== '' && fromYear !== 'null') ? fromYear : '0';
            const effectiveToYear = (toYear && toYear !== '' && toYear !== 'null') ? toYear : '';
            const yearRange = effectiveToYear 
                ? `year-${effectiveFromYear}-${effectiveToYear}` 
                : `year-${effectiveFromYear}`;
            pathSegments.push(yearRange);
        }

        // Handle hours range
        const fromHours = formData.get('FromHours');
        const toHours = formData.get('ToHours');
        if ((fromHours && fromHours !== '' && fromHours !== 'null') || (toHours && toHours !== '' && toHours !== 'null')) {
            const effectiveFromHours = (fromHours && fromHours !== '' && fromHours !== 'null') ? fromHours : '0';
            const effectiveToHours = (toHours && toHours !== '' && toHours !== 'null') ? toHours : '';
            const hoursRange = effectiveToHours 
                ? `hours-${effectiveFromHours}-${effectiveToHours}` 
                : `hours-${effectiveFromHours}`;
            pathSegments.push(hoursRange);
        }

        // Handle price range
        const fromPrice = formData.get('FromPrice');
        const toPrice = formData.get('ToPrice');
        if ((fromPrice && fromPrice !== '' && fromPrice !== 'null') || (toPrice && toPrice !== '' && toPrice !== 'null')) {
            const effectiveFromPrice = (fromPrice && fromPrice !== '' && fromPrice !== 'null') ? fromPrice : '0';
            const effectiveToPrice = (toPrice && toPrice !== '' && toPrice !== 'null') ? toPrice : '';
            const priceRange = effectiveToPrice 
                ? `price-${effectiveFromPrice}-${effectiveToPrice}` 
                : `price-${effectiveFromPrice}`;
            pathSegments.push(priceRange);
        }

        // Handle gallery view
        const isGallery = formData.get('IsGallery');
        if (isGallery === 'true') {
            pathSegments.push('gallery-true');
        }

        // Add remaining filters as query parameters (only SortBy, PageSize, PageNumber)
        formFieldNames.forEach(fieldName => {
            const value = formData.get(fieldName);
            if (value && value !== '' && value !== 'null' && value !== 'false') {
                if (fieldName === 'PageNumber' && isFilter) {
                    // Skip PageNumber for filter actions
                    return;
                }
                if (fieldName === 'PageSize' && value === '24') {
                    // Skip default page size
                    return;
                }
                // Skip all fields that are now in path segments
                if (['State', 'ZipCode', 'Distance', 'DriveTypeID', 'FromLength', 'ToLength', 
                     'FromYear', 'ToYear', 'FromHours', 'ToHours', 'FromPrice', 'ToPrice', 'IsGallery'].includes(fieldName)) {
                    return;
                }
                urlParams.set(fieldName, value);
            }
        });

        // Handle pagination
        if (isFilter) {
            const pageNumberInput = form.querySelector('input[name="PageNumber"]');
            if (pageNumberInput) {
                pageNumberInput.value = '1';
            }
        } else {
            let pageNumber = null;
            const pageNumberInput = form.querySelector('input[name="PageNumber"]');
            if (pageNumberInput && pageNumberInput.value) {
                pageNumber = pageNumberInput.value;
            }
            if (!pageNumber && resultsForm) {
                const resultsPageNumberInput = resultsForm.querySelector('input[name="PageNumber"]');
                if (resultsPageNumberInput && resultsPageNumberInput.value) {
                    pageNumber = resultsPageNumberInput.value;
                }
            }
            if (!pageNumber) {
                const currentUrl = new URLSearchParams(window.location.search);
                pageNumber = currentUrl.get('PageNumber') || currentUrl.get('page');
            }
            if (pageNumber && pageNumber !== '' && pageNumber !== 'null' && pageNumber !== '1') {
                urlParams.set('PageNumber', pageNumber);
            }
        }

        // Build final URL - avoid encoding for simple alphanumeric characters
        if (pathSegments.length > 0) {
            pathUrl += pathSegments.join('/') + '/';
        }
        
        const queryString = urlParams.toString();
        return queryString ? `${pathUrl}?${queryString}` : pathUrl;
    }

    // Function to get filter string with specific page number for pagination
    function getFilterStringWithPage(pageNumber) {
        const form = document.getElementById('boatsSearch');
        const resultsForm = document.getElementById('boatResultsForm');
        if (!form) return '/used-ski-boats/?PageNumber=' + pageNumber;

        // Update the PageNumber input in main form
        const pageNumberInput = form.querySelector('input[name="PageNumber"]');
        if (pageNumberInput) {
            pageNumberInput.value = pageNumber;
        }

        // Get filter string with pagination (not a filter action)
        const fullUrl = getFilterString(false);

        // Parse the URL to add/update page number
        const [pathPart, queryPart] = fullUrl.split('?');
        const urlParams = new URLSearchParams(queryPart || '');

        // Set the specific page number
        if (pageNumber && pageNumber !== '1') {
            urlParams.set('PageNumber', pageNumber);
        } else {
            urlParams.delete('PageNumber');
        }

        const queryString = urlParams.toString();
        const result = queryString ? `${pathPart}?${queryString}` : pathPart;

        return result;
    }

    // Function specifically for form submissions (always filter actions)
    function getFilterStringForFormSubmission() {
        // Only reset PageNumber to 1 if this is NOT a popstate navigation
        if (!isPopstateNavigation) {
            const form = document.getElementById('boatsSearch');
            if (form) {
                const pageNumberInput = form.querySelector('input[name="PageNumber"]');
                if (pageNumberInput) {
                    pageNumberInput.value = '1';
                }
            }
        }

        // For popstate navigation, don't treat as filter action
        return getFilterString(!isPopstateNavigation);
    }

    // Flag to track if we're in popstate navigation
    let isPopstateNavigation = false;

    // Flag to track if the current action is filtering
    let isCurrentActionFilter = false;

    // Function to update URL with current filter values
    function updateUrlWithFilters(isFilter = false) {
        // Don't update URL if we're in popstate navigation
        if (isPopstateNavigation) {
            return;
        }

        // Use the tracked filter action flag if no explicit parameter
        const fullUrl = getFilterString(isFilter);

        // Use pushState to create history entries for both pagination and filters
        window.history.pushState({}, '', fullUrl);

        // Reset the flag after use
        isCurrentActionFilter = false;
    }

    function updateMetaInformation(metaTitle, metaDescription) {
        if (metaTitle) {
            document.title = metaTitle;
        }

        if (metaDescription) {
            let metaDescElement = document.querySelector('meta[name="description"]');
            if (!metaDescElement) {
                // Create meta description element if it doesn't exist
                metaDescElement = document.createElement('meta');
                metaDescElement.setAttribute('name', 'description');
                document.head.appendChild(metaDescElement);
            }
            metaDescElement.setAttribute('content', metaDescription);
        }
    }


    // Make functions globally available
    window.getFilterString = getFilterString;
    window.getFilterStringWithPage = getFilterStringWithPage;
    window.getFilterStringForFormSubmission = getFilterStringForFormSubmission;
    window.updateUrlWithFilters = updateUrlWithFilters;

    // Function to populate form from URL parameters on page load
    function populateFormFromUrl() {
        const urlParams = new URLSearchParams(window.location.search);
        const form = document.getElementById('boatsSearch');
        if (!form) return;

        // Parse path segments first
        parsePathSegments(form);

        formFieldNames.forEach(fieldName => {
            let value = urlParams.get(fieldName);

            // Special handling for PageNumber - also check for 'page' parameter for backward compatibility
            if (fieldName === 'PageNumber' && !value) {
                value = urlParams.get('page');
            }

            if (value) {
                const field = form.querySelector(`[name="${fieldName}"]`);
                if (field) {
                    if (field.type === 'checkbox') {
                        field.checked = value === 'true';
                    } else {
                        field.value = value;
                    }
                }
            }
        });

        // Handle SortBy and PageSize from partial view dropdowns
        const sortByValue = urlParams.get('SortBy');
        if (sortByValue) {
            const sortByElement = document.getElementById('SortBy');
            if (sortByElement) {
                sortByElement.value = sortByValue;
            }
        }

        const pageSizeValue = urlParams.get('PageSize');
        if (pageSizeValue) {
            const pageSizeElement = document.getElementById('pageSize');
            if (pageSizeElement) {
                pageSizeElement.value = pageSizeValue;
            }
        }

        // States, makes, and models are already set via asp-for from backend, no need to parse from URL

        // Handle gallery view toggle
        const isGallery = urlParams.get('IsGallery');
        if (isGallery === 'true') {
            $("#view-gallery").addClass("active");
            $("#view-list").removeClass("active");
            $(".oib-boat-container").addClass("oib-gallery");
            $(".oib-boat-container").removeClass("oib-list");
            $("#IsGallery").val(true);
        } else if (isGallery === 'false') {
            $("#view-list").addClass("active");
            $("#view-gallery").removeClass("active");
            $(".oib-boat-container").addClass("oib-list");
            $(".oib-boat-container").removeClass("oib-gallery");
            $("#IsGallery").val(false);
        }
    }

    // Parse SEO-friendly path segments
    function parsePathSegments(form) {
        const pathSegments = window.location.pathname.split('/').filter(segment => segment && segment !== 'used-ski-boats');
        
        pathSegments.forEach(segment => {
            // States are already set via asp-for="State", no need to parse from URL
            if (segment.startsWith('zip-')) {
                const zipCode = decodeURIComponent(segment.substring(4));
                const zipField = form.querySelector('input[name="ZipCode"]');
                if (zipField) {
                    zipField.value = zipCode;
                }
            }
            else if (segment.startsWith('radius-')) {
                const radius = decodeURIComponent(segment.substring(7));
                const distanceField = form.querySelector('select[name="Distance"]');
                if (distanceField) {
                    distanceField.value = radius;
                }
            }
            else if (segment.startsWith('drivetype-')) {
                const driveTypeName = decodeURIComponent(segment.substring(10));
                const driveTypeSelect = form.querySelector('select[name="DriveTypeID"]');
                if (driveTypeSelect) {
                    const option = Array.from(driveTypeSelect.options).find(opt => 
                        opt.textContent.toLowerCase().replace(/\s+/g, '-') === driveTypeName);
                    if (option) {
                        option.selected = true;
                        driveTypeSelect.dispatchEvent(new Event('change'));
                    }
                }
            }
            else if (segment.startsWith('makemodel-')) {
                // Parse models from URL (makes are already set via asp-for)
                // Don't decode here - parseModelDataFromUrl will handle decoding
                const makeModelData = segment.substring(10);
                parseModelDataFromUrl(form, makeModelData);
            }
            else if (segment.startsWith('length-')) {
                const lengthData = decodeURIComponent(segment.substring(7));
                parseRangeData(form, 'FromLength', 'ToLength', lengthData);
            }
            else if (segment.startsWith('year-')) {
                const yearData = decodeURIComponent(segment.substring(5));
                parseRangeData(form, 'FromYear', 'ToYear', yearData);
            }
            else if (segment.startsWith('hours-')) {
                const hoursData = decodeURIComponent(segment.substring(6));
                parseRangeData(form, 'FromHours', 'ToHours', hoursData);
            }
            else if (segment.startsWith('price-')) {
                const priceData = decodeURIComponent(segment.substring(6));
                parseRangeData(form, 'FromPrice', 'ToPrice', priceData);
            }
            else if (segment.startsWith('gallery-')) {
                const galleryValue = decodeURIComponent(segment.substring(8));
                const galleryField = form.querySelector('input[name="IsGallery"]');
                if (galleryField) {
                    galleryField.value = galleryValue === 'true';
                }
            }
        });
    }

    // Parse models from URL (makes are already set via asp-for)
    function parseModelDataFromUrl(form, makeModelData) {
        // Try to decode, but handle case where it's already decoded
        let decodedData;
        try {
            decodedData = decodeURIComponent(makeModelData);
        } catch (e) {
            // If decoding fails, use original (might already be decoded)
            decodedData = makeModelData;
        }
        
        const pairs = decodedData.split('&');
        const modelNames = [];

        pairs.forEach(pair => {
            if (pair.includes(':')) {
                const parts = pair.split(':');
                if (parts.length === 2) {
                    // Keep underscores as they are in URL (they represent spaces in original model names)
                    const modelName = parts[1].trim();
                    if (modelName) {
                        modelNames.push(modelName);
                    }
                }
            }
        });

        // Store model names globally so loadModelsForMake can use them
        // Initialize as array if it doesn't exist, or append to existing
        if (modelNames.length > 0) {
            if (!window.pendingModelSelections) {
                window.pendingModelSelections = [];
            }
            // Clear existing and set new (don't append, replace)
            window.pendingModelSelections = [...modelNames];
        }
    }

    // Parse range data (e.g., "17-29" or "17")
    function parseRangeData(form, fromFieldName, toFieldName, rangeData) {
        if (rangeData.includes('-')) {
            const parts = rangeData.split('-');
            const fromField = form.querySelector(`select[name="${fromFieldName}"]`);
            const toField = form.querySelector(`select[name="${toFieldName}"]`);
            
            if (fromField && parts[0]) {
                fromField.value = parts[0];
            }
            if (toField && parts[1]) {
                toField.value = parts[1];
            }
        } else {
            const fromField = form.querySelector(`select[name="${fromFieldName}"]`);
            if (fromField) {
                fromField.value = rangeData;
            }
        }
    }

    // Handle browser back/forward navigation
    window.addEventListener('popstate', function (event) {
        // Set flag to prevent URL updates during popstate navigation
        isPopstateNavigation = true;

        // Populate form from URL parameters
        populateFormFromUrl();

        // Small delay to ensure form is populated before triggering search
        setTimeout(function () {
            const submitBtn = document.getElementById('BoatsSearchSubmit');
            if (submitBtn) {
                submitBtn.click();
            }
        }, 50);
    });

    // Function to update meta tags and page title on page load using model values
    function updateMetaAndTitleOnPageLoad() {
        // Get meta data from data attributes (set by server-side in BoatsListPage_Default.cshtml)
        const mainTitleDiv = document.querySelector('.oib-main-title');
        if (!mainTitleDiv) {
            return;
        }

        const metaTitle = mainTitleDiv.dataset.metaTitle;
        const metaDescription = mainTitleDiv.dataset.metaDescription;

        if (metaTitle && metaTitle !== 'Boats For Sale') {
            updateMetaInformation(metaTitle, metaDescription);

            // Update page title (H1 element)
            const firstH1 = mainTitleDiv.querySelector('h1:first-child');
            if (firstH1) {
                firstH1.textContent = metaTitle;
            }
        }
    }

    // Function to update meta tags and page title after HTMX swap using response headers
    function updateMetaAndTitleAfterSwap(event) {
        // Get meta data from response headers
        const metaTitle = event.detail.xhr.getResponseHeader('X-Meta-Title');
        const metaDescription = event.detail.xhr.getResponseHeader('X-Meta-Description');
        
        if (metaTitle && metaTitle !== 'Boats For Sale') {
            updateMetaInformation(metaTitle, metaDescription);
            
            // Update page title (H1 element)
            const mainTitleDiv = document.querySelector('.oib-main-title');
            if (mainTitleDiv) {
                const firstH1 = mainTitleDiv.querySelector('h1:first-child');
                if (firstH1) {
                    firstH1.textContent = metaTitle;
                }
            }
        }
    }

    // Initialize all Choices.js dropdowns
    function initializeChoicesDropdowns() {
        // Initialize makes dropdown with Choices.js and event listener
        const makesSelect = document.getElementById('ItemTypes');

        if (makesSelect) {
            // Initialize Choices.js for makes dropdown
            // Choices.js automatically reads selected options from the DOM (set by asp-for)
            window.makesChoice = new Choices(makesSelect, {
                removeItemButton: true,
                searchEnabled: true,
                searchChoices: true,
                noResultsText: 'No makes found',
                noChoicesText: 'No makes available',
                itemSelectText: 'Click to select',
                placeholder: true,
                placeholderValue: 'Select makes...',
                searchPlaceholderValue: 'Search makes...'
            });

            // Add high z-index to the makes dropdown container
            setTimeout(() => {
                const dropdown = document.querySelector('#ItemTypes + .choices .choices__list--dropdown');
                if (dropdown) {
                    dropdown.style.zIndex = '9999';
                }
            }, 100);

            // Add event listener for change
            makesSelect.addEventListener('change', function() {
                itemTypesChange();
                // Auto-collapse after selection
                window.makesChoice.hideDropdown();
            });

            // Ensure dropdown appears on top when opened
            makesSelect.addEventListener('showDropdown', function() {
                ensureDropdownZIndex();
            });
        }
        
        // Initialize Choices.js for states dropdown (using unique class to avoid conflict with search-menu-home.js)
        const statesSelect = document.getElementById('StateBoats');
        if (statesSelect) {
            // Get already selected values from asp-for (they are already selected in the DOM)
            const selectedStateValues = Array.from(statesSelect.selectedOptions).map(opt => opt.value);
            
            window.statesChoice = new Choices(statesSelect, {
                removeItemButton: true,
                searchEnabled: true,
                searchChoices: true,
                noResultsText: 'No states found',
                noChoicesText: 'No states available',
                itemSelectText: 'Click to select',
                placeholder: true,
                placeholderValue: 'Select states...',
                searchPlaceholderValue: 'Search states...'
            });
            
            // Ensure selected values are set in Choices.js (asp-for already set them in DOM)
            if (selectedStateValues.length > 0) {
                setTimeout(() => {
                    try {
                        window.statesChoice.setValue(selectedStateValues);
                    } catch (e) {
                        // Ignore errors
                    }
                }, 50);
            }

            // Add high z-index to the states dropdown container
            setTimeout(() => {
                const dropdown = document.querySelector('#StateBoats + .choices .choices__list--dropdown');
                if (dropdown) {
                    dropdown.style.zIndex = '9999';
                }
            }, 100);

            // Ensure dropdown appears on top when opened
            statesSelect.addEventListener('showDropdown', function() {
                ensureDropdownZIndex();
            });
        }
    }

    // Function to create model selects for already selected makes (from backend)
    function createModelSelectsForSelectedMakes() {
        const makeSelect = document.getElementById('ItemTypes');
        if (!makeSelect) return;
        
        // Read selected options from the original select element (not from Choices.js)
        // This ensures we get the values set by asp-for, even if Choices.js hasn't updated yet
        const selectedMakes = Array.from(makeSelect.selectedOptions);
        
        if (selectedMakes.length === 0) {
            return;
        }
        
        // Trigger itemTypesChange to create model selects
        // Models will be selected from URL via window.pendingModelSelections in loadModelsForMake
        itemTypesChange();
    }

    // Initial sync when page loads
    // Function to run when DOM is ready
    function onDOMReady() {
        // Reset popstate flag on page load
        isPopstateNavigation = false;

        // First, initialize all Choices.js dropdowns
        initializeChoicesDropdowns();
        
        // Small delay to ensure Choices.js is fully initialized
        setTimeout(() => {
            const form = document.getElementById('boatsSearch');
            if (form) {
                // First, parse path segments to extract model names from URL
                parsePathSegments(form);
            }
            
            // Then populate other form fields from URL query params
            populateFormFromUrl();
            
            // Wait a bit more to ensure Choices.js has updated the UI with selected values
            setTimeout(() => {
                // Create model selects for already selected makes (from backend)
                // Models will be selected from URL via window.pendingModelSelections
                createModelSelectsForSelectedMakes();
                
                syncFilterValues();
            }, 200); // Additional delay to ensure Choices.js UI is updated
        }, 100);


        updateImagesGalaries();

        // Update meta tags and page title on page load
        updateMetaAndTitleOnPageLoad();

        // Periodically ensure dropdowns have correct z-index
        setInterval(ensureDropdownZIndex, 500);
    }

    // Check if DOM is already ready (module loaded after DOMContentLoaded)
    if (document.readyState === 'loading') {
        // DOM is still loading, wait for DOMContentLoaded
        document.addEventListener('DOMContentLoaded', onDOMReady);
    } else {
        // DOM is already ready, execute immediately
        onDOMReady();
    }

    // Also sync immediately if called from partial
    syncFilterValues();


    // Handle view toggle buttons - these should NOT create new history entries
    $(document).on('click', '#view-gallery', function () {
        $("#view-gallery").addClass("active");
        $("#view-list").removeClass("active");
        $(".oib-boat-container").addClass("oib-gallery");
        $(".oib-boat-container").removeClass("oib-list");
        $("#IsGallery").val(true);

        // Update URL without creating history entry (use replaceState)
        const filterString = getFilterString(false);
        const url = new URL(window.location.href);
        const filterParams = new URLSearchParams(filterString);
        url.search = '';
        filterParams.forEach((value, key) => {
            url.searchParams.set(key, value);
        });
        window.history.replaceState({}, '', url.toString());
    });

    $(document).on('click', '#view-list', function () {
        $("#view-list").addClass("active");
        $("#view-gallery").removeClass("active");
        $(".oib-boat-container").addClass("oib-list");
        $(".oib-boat-container").removeClass("oib-gallery");
        $("#IsGallery").val(false);

        // Update URL without creating history entry (use replaceState)
        const filterString = getFilterString(false);
        const url = new URL(window.location.href);
        const filterParams = new URLSearchParams(filterString);
        url.search = '';
        filterParams.forEach((value, key) => {
            url.searchParams.set(key, value);
        });
        window.history.replaceState({}, '', url.toString());
    });

    // iOS Safari Fix: Add cursor pointer for proper event bubbling
    // Reference: https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
    function applyIOSSafariFix() {
        // Detect iOS Safari
        const isIOSSafari = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

        if (isIOSSafari) {
            // Add cursor pointer to enable proper event bubbling on iOS Safari
            // Reference: https://gravitydept.com/blog/js-click-event-bubbling-on-ios
            const style = document.createElement('style');
            style.textContent = `
                .ios-safari-fix * {
                    cursor: pointer !important;
                }
            `;
            document.head.appendChild(style);
            document.documentElement.classList.add('ios-safari-fix');
        }
    }

    // Simple mobile dropdown protection - just prevent price dropdown interference
    function addMobileDropdownProtection(element, shouldSubmit = true) {
        if (!element) return;

        // Only add minimal protection to prevent price dropdown from opening during submission
        element.addEventListener('touchstart', function (e) {
            // Quick blur of form elements to prevent dropdowns
            setTimeout(() => {
                const formElements = document.querySelectorAll('select, input, textarea');
                formElements.forEach(formElement => {
                    if (formElement.blur) {
                        formElement.blur();
                    }
                });

                if (shouldSubmit) {
                    submitClick();
                }
            }, 50);
        });
    }

    // Apply iOS Safari fix first
    applyIOSSafariFix();

    // Apply mobile protection to submit button only
    const submitButton = document.getElementById('BoatsSearchSubmit');
    addMobileDropdownProtection(submitButton, true);

    // For main search dropdowns, let them work normally with iOS Safari fix
    // No aggressive protection needed - just normal form behavior

    // HTMX handles all form submission automatically
    // No need for manual submission tracking

    // HTMX event listeners for URL management
    document.addEventListener('htmx:afterRequest', function (event) {
        // Check if the request is from the boats search form
        if (event.detail.elt && event.detail.elt.id === 'boatsSearch') {
            // Update URL after successful request
            if (!isPopstateNavigation) {
                updateUrlWithFilters(isCurrentActionFilter);
            }
        }

        // Enable all selects after HTMX request
        enableAllSelects();
        hideButtonLoading();
    });

    // Mobile Filter Bar Functionality
    function initializeMobileButtons() {
        const mobileFiltersBtn = document.getElementById('mobileFiltersBtn');
        const mobileSortBtn = document.getElementById('mobileSortBtn');
        const mobileListingsBtn = document.getElementById('mobileListingsBtn');
        const filterSidebar = document.getElementById('mainFilterSidebar');
        const sortOverlay = document.getElementById('mobileSortOverlay');
        const listingsOverlay = document.getElementById('mobileListingsOverlay');

        // Mobile Filters button
        if (mobileFiltersBtn) {
            mobileFiltersBtn.addEventListener('click', function () {
                this.classList.toggle('active');
                if (filterSidebar) {
                    filterSidebar.style.display = this.classList.contains('active') ? 'block' : 'none';
                }
            });
        }

        // Mobile Sort button
        if (mobileSortBtn) {
            mobileSortBtn.addEventListener('click', function () {
                sortOverlay.classList.add('active');
                document.body.style.overflow = 'hidden';

                // Update selected option based on current SortBy value
                const currentSortBy = document.getElementById('SortBy')?.value || '0';
                document.querySelectorAll('.mobile-sort-option').forEach(option => {
                    option.classList.toggle('selected', option.dataset.value === currentSortBy);
                });
            });
        }

        // Mobile Listings button
        if (mobileListingsBtn) {
            mobileListingsBtn.addEventListener('click', function () {
                listingsOverlay.classList.add('active');
                document.body.style.overflow = 'hidden';

                // Update selected option based on current PageSize value
                const currentPageSize = document.getElementById('pageSize')?.value || '24';
                document.querySelectorAll('.mobile-listings-option').forEach(option => {
                    option.classList.toggle('selected', option.dataset.value === currentPageSize);
                });
            });
        }

        // Sort option selection
        document.querySelectorAll('.mobile-sort-option').forEach(option => {
            option.addEventListener('click', function () {
                const sortBySelect = document.getElementById('SortBy');
                if (sortBySelect) {
                    sortBySelect.value = this.dataset.value;

                    // Trigger change event to submit form
                    const changeEvent = new Event('change', { bubbles: true });
                    sortBySelect.dispatchEvent(changeEvent);
                }
                closeMobileSortOverlay();
            });
        });

        // Listings option selection
        document.querySelectorAll('.mobile-listings-option').forEach(option => {
            option.addEventListener('click', function () {
                const pageSizeSelect = document.getElementById('pageSize');
                if (pageSizeSelect) {
                    pageSizeSelect.value = this.dataset.value;

                    // Trigger change event to submit form
                    const changeEvent = new Event('change', { bubbles: true });
                    pageSizeSelect.dispatchEvent(changeEvent);
                }
                closeMobileListingsOverlay();
            });
        });

        // Close overlay when clicking outside
        if (sortOverlay) {
            sortOverlay.addEventListener('click', function (e) {
                if (e.target === this) {
                    closeMobileSortOverlay();
                }
            });
        }

        if (listingsOverlay) {
            listingsOverlay.addEventListener('click', function (e) {
                if (e.target === this) {
                    closeMobileListingsOverlay();
                }
            });
        }

        // Window resize handler to fix responsive design issue for used-ski-boats page
        window.addEventListener('resize', function () {
            const isDesktop = window.innerWidth > 1000;

            if (isDesktop) {
                // On desktop: always show filter sidebar, reset mobile button state
                if (filterSidebar) {
                    filterSidebar.style.display = 'block';
                }
                if (mobileFiltersBtn) {
                    mobileFiltersBtn.classList.remove('active');
                }

                // Close any open mobile overlays
                if (sortOverlay) {
                    sortOverlay.classList.remove('active');
                }
                if (listingsOverlay) {
                    listingsOverlay.classList.remove('active');
                }
                document.body.style.overflow = '';
            } else {
                // On mobile: hide filter sidebar by default (unless active)
                if (filterSidebar && !mobileFiltersBtn?.classList.contains('active')) {
                    filterSidebar.style.display = 'none';
                }
            }
        });
    }

    // Call initializeMobileButtons immediately if DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initializeMobileButtons);
    } else {
        initializeMobileButtons();
    }

    // Global functions for closing overlays
    function closeMobileSortOverlay() {
        const sortOverlay = document.getElementById('mobileSortOverlay');
        if (sortOverlay) {
            sortOverlay.classList.remove('active');
            document.body.style.overflow = '';
        }
    }

    function closeMobileListingsOverlay() {
        const listingsOverlay = document.getElementById('mobileListingsOverlay');
        if (listingsOverlay) {
            listingsOverlay.classList.remove('active');
            document.body.style.overflow = '';
        }
    }

    // Make functions globally available
    window.closeMobileSortOverlay = closeMobileSortOverlay;
    window.closeMobileListingsOverlay = closeMobileListingsOverlay;


    // Initialize the boats search functionality
    attachTitleUpdateListeners();
}

